import { render } from "./SelectImageFromGalleryContent.vue?vue&type=template&id=9381ffc4&scoped=true"
import script from "./SelectImageFromGalleryContent.vue?vue&type=script&lang=js"
export * from "./SelectImageFromGalleryContent.vue?vue&type=script&lang=js"

import "./SelectImageFromGalleryContent.vue?vue&type=style&index=0&id=9381ffc4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9381ffc4"]])

export default __exports__